export const DisplayMode = {
  List: 'list',
  Map: 'map',
  Mixed: 'mixed',
};
